// import './preloader';

import "./helpers/expandedText";

// mixins
import "./mixins/accordion";
import "./mixins/nav";
import "./mixins/modal";
import "./mixins/video";
import "./mixins/article-slider";
import "./mixins/text-with-title";

// components
import "./slider";
import "./form";
import "./header";
import "./history";
import "./header-language";
import "./modal-callback";
import "./main/callback";
import "./main/banner";
import "./main/catalog";
import "./main/premium-kit";
import "./main/adjustSwitcherWidth";
import "./cache";
import "./our-traditions";
import "./faq";
import "./button";
import "./tuning-kit/banner";
import "./tuning-kit/beaf";
import "./tuning-kit/testimonials";
import "./tuning-kit/slider";
import "./tuning-kit/product-slider";
import "./tuning-kit/tuning";
import "./tuning-kit/tuning-sets";
import "./tuning-kit/quiz";
import "./tuning-kit/tuning-kit-part-detail";
import "./wheel/wheel-slider";
import "./article";
import "./blog";
import "./reviews";
import "./about";
import "./main/self-expression";
import "./models";
import "./advantages";
import "./input-country";
import "./dealers/dealers";
import "./dealers/dealers-list";
import "./slider-reviews";
import "./star-rating";
import "./slider-thumbs";
import "./details-list";
import "./share-socials";
import "./wishlist";
import "./scroll-to";

const resize = () => {
  document.documentElement.style.setProperty("--vh", `${window.innerHeight}px`);
  document.documentElement.style.setProperty("--vw-outer", `${window.innerWidth}px`);
  document.documentElement.style.setProperty("--vh-outer", `${window.innerHeight}px`);
  document.documentElement.style.setProperty("--bottom-bar", `${window.screen.height - window.innerHeight}px`);
};

window.addEventListener("resize", resize);
resize();
